// extracted by mini-css-extract-plugin
export default {"componentWrapper":"FormElement_componentWrapper__iW5Op","formElementHalfWidth":"FormElement_formElementHalfWidth__FginD"};